import React from 'react';
import * as VALIDITY_PROPERTIES from './validityProperties';
import * as FILTERS from './filters';
import DEFAULT_LOCATION from './defaultLocation';
import STATES from './states';
import PROFILE_REDIRECTS from './profileRedirects';
import SUBURB_REDIRECTS from './suburbRedirects';
import CATEGORY_EXCLUSIONS from './categoryExclusions';
import CATEGORY_REDIRECTS from './categoryRedirects';
import DIGITAL_MARKETING_LISTVIEW_REDIRECTS from './digitalMarketingListviewRedirects';
import LISTVIEW_TITLE_TAGS from './listviewTitleTags';
import LISTVIEW_SECONDARY_HEADING from './listviewSecondaryHeading';
import LISTVIEW_PRIMARY_H1 from './listviewPrimaryH1';
import { LISTING_POST_STATES } from './listingPosts';
import {
  Open247Icon,
  OpenLateIcon,
  OpenNowIcon,
  BestMatchIcon,
  NearMeIcon,
  RecentlyReviewedIcon,
  TopRatedIcon,
} from '../assets/filters';

import {
  PlumbersIcon,
  BuildersIcon,
  MechanicsIcon,
  DentistIcon,
  MassageIcon,
  CleanersIcon,
  HairdressersIcon,
} from '../assets/landing';

const MODALS = {
  ENQUIRY_FORM: 'EnquiriesForm',
  REVIEW_FORM: 'ReviewForm',
  REVIEW_UPDATE_FORM: 'ReviewUpdateForm',
  REVIEW_PERSONIV_FORM: 'ReviewPersonivForm',
  SUGGEST_EDIT_FORM: 'SuggestEditForm',
  MODAL_CONFIRMATION: 'ModalConfirmation',
  REVIEW_RATING_CONFIRMATION: 'ReviewRatingConfirmation',
  DATE_PICKER: 'DatePicker',
  HEADER_SLIDE_MENU: 'HeaderSlideMenu',
  SEARCH_AUTOSUGGEST: 'SearchAutoSuggest',
  CLAIM_BUSINESS_FORM: 'ClaimBusinessForm',
  QUOTE_FORM: 'QuoteForm',
  SHARE: 'Share',
  FILTERS_MOBILE: 'FiltersMobile',
  FILTERS_SORT_BY_MOBILE: 'FiltersSortByMobile',
  ADD_A_BUSINESS: 'AddABusiness',
  TRADING_HOURS: 'TradingHours',
  PROFILE_TRADING_HOURS: 'ProfileTradingHours',
  USER_LOGOUT: 'UserLogout',
  FAVOURITES_MODAL: 'FavouritesModal',
  USER_REVIEW_DELETE: 'UserReviewDelete',
  WELCOME_SUCCESS: 'welcomeSuccessModal',
};

const COOKIES = {
  USER_LAST_LOCATION: 'user_last_location',
  REVIEW_FORM: 'ReviewForm',
  NOTIFICATION_ALERT_BANNER: '_ls_notification_alert_banner',
  LS_USER: 'ls_user',
};

const STANDARD_PHONE_REGEX = '^[0-9 +]{4,12}$';
const PHONE_REGEX =
  '(^(1300|1800|1900|1902)(| )[0-9]{3}(| )[0-9]{3}$)|(^0[2|3|7|8]{1}(| )[0-9]{4}(| )[0-9]{4}$)|(^13(| )[0-9]{4}$)|(^13[0-9]{1}(| )[0-9]{3}$)|((^0[4-5][0-9]{2,3})(| )[0-9]{3}(| )[0-9]{3}$)|((^61(| )[4-5][0-9]{0,4})(| )[0-9]{3,4}(| )[0-9]{3,4}$)';
const MISSING_AREACODE_REGEX = '^[0-9]{4}(| )[0-9]{4}$';
const MOBILE_REGEX =
  '^(0[4-5][0-9]{2,3})(| )[0-9]{3}(| )[0-9]{3}$|(^61(| )[4-5][0-9]{0,4})(| )[0-9]{3,4}(| )[0-9]{3,4}$';
const EMAIL_REGEX = '';
const CHARACTERS_ONLY_REGEX = "^[a-zA-Z-',]+(s{0,1}[a-zA-Z-', ])*$";
const ALPHANUMERIC_REGEX = "^[a-zA-Z0-9-_ ',.&]*$";
const LISTVIEW_PAGE_SIZE = 40;

const SORT_BY_FILTERS = [
  {
    label: 'Suggested',
    type: 'sortBy',
    checked: true,
    value: 'r',
  },
  {
    label: 'Top Rated',
    type: 'sortBy',
    checked: false,
    value: 's',
  },
  {
    label: 'Near Me',
    type: 'sortBy',
    checked: false,
    value: 'd',
  },
  {
    label: 'Recently Reviewed',
    type: 'sortBy',
    checked: false,
    value: 'rr',
  },
];

const SORT_BY_FILTER_ICONS = (label, focused) => {
  const ICONS = {
    Suggested: (
      <BestMatchIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
    'Top Rated': (
      <TopRatedIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
    'Near Me': (
      <NearMeIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
    'Recently Reviewed': (
      <RecentlyReviewedIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
  };
  return ICONS[label];
};

const TRADING_HOURS_FILTER_ICONS = (label, focused) => {
  const ICONS = {
    'Open Now': (
      <OpenNowIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
    'Open Late': (
      <OpenLateIcon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
    'Open 24/7': (
      <Open247Icon
        color={focused ? 'var(--color-lsBlue)' : 'var(--color-primary)'}
      />
    ),
  };
  return ICONS[label];
};

const WAYS_TO_PAY_FILTER_ICONS = {
  account: 'icon-categorylibraries',
  afterpay: 'icon-categorycarparkpayanddisplay',
  'apple pay': 'icon-categorypaymenttypemobile',
  bitcoin: 'icon-categorycarparkpayanddisplay',
  bpay: 'icon-categorycomputers',
  'bulk billing': 'icon-categoryplaceofworship',
  cash: 'icon-categoryfinancialservices',
  cheque: 'icon-categoryatmdepositcheque',
  'direct debit': 'icon-generalbook',
  eft: 'icon-generalsort',
  'fully insured': 'icon-categoryinsurance',
  'gift vouchers': 'icon-categoryartsandentertainment',
  'google pay': 'icon-categorypaymenttypemobile',
  hicaps: 'icon-categoryprofessionalservices',
  humm: 'icon-categorycarparkpayanddisplay',
  'interest free plans': 'icon-generalquote',
  paypal: 'icon-categorypaymenttypemobile',
  'seniors discounts': 'icon-categoryorganisations',
  'zip pay': 'icon-categorycarparkpayanddisplay',
  default: 'icon-categorypaymenttypecards',
};

const QUOTES_SERVICES = {
  Installation: 'installation',
  Repairs: 'repair',
  'On-going help': 'ongoing',
  'One-off job': 'oneOff',
  'Commercial project': 'commercial',
  Other: 'other',
};

const QUOTES_SERVICES_REVERSE = {
  installation: 'Installation',
  repair: 'Repairs',
  ongoing: 'On-going help',
  oneOff: 'One-off job',
  commercial: 'Commercial project',
  other: 'Other',
};

const TRADING_HOURS_CAPTIONS = [
  {
    label: 'Open',
    value: 'Open',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Open 24hrs',
    value: 'Open 24hrs',
    hasOpenClose: false,
  },
  {
    label: 'Flexible Hours',
    value: 'Flexible Hours',
    hasOpenClose: false,
  },
  {
    label: 'By Appointment',
    value: 'By Appt',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Extended Hours',
    value: 'Extended Hours',
    hasOpenClose: false,
  },
  {
    label: 'On Call',
    value: 'On Call',
    hasOpenClose: false,
  },
  {
    label: 'After Hours',
    value: 'After Hours',
    hasOpenClose: false,
  },
  {
    label: 'Emergency',
    value: 'Emergency',
    hasOpenClose: false,
  },
  {
    label: 'Closed',
    value: 'Closed',
    hasOpenClose: false,
  },
  {
    label: 'Temporarily Closed',
    value: 'Temporarily Closed',
    hasOpenClose: false,
  },
  {
    label: 'Online Only',
    value: 'Online Only',
    hasOpenClose: false,
  },
  {
    label: 'Take Away Only',
    value: 'Take Away Only',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
  {
    label: 'Delivery Only',
    value: 'Delivery Only',
    open: '08:30',
    close: '17:00',
    hasOpenClose: true,
  },
];

const TRADING_HOURS_CAPTION_COLORS = {
  default: '#00a699',
  Open: '#00a699',
  'Open Today': '#00a699',
  'Open 24hrs': '#00a699',
  'Flexible Hours': '#00a699',
  'By Appt': '#00a699',
  'Extended Hours': '#00a699',
  Emergency: '#e48f37',
  'On Call': '#e48f37',
  'After Hours': '#e48f37',
  Closed: '#f16159',
  'Temporarily Closed': '#f16159',
  'Online Only': '#757575',
  'Take Away Only': '#757575',
  'Delivery Only': '#757575',
  'Closing Soon': '#ed8a39',
};

const DEFAULT_TRADING_HOURS = [
  {
    day: 'Monday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 1,
  },
  {
    day: 'Tuesday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 2,
  },
  {
    day: 'Wednesday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 3,
  },
  {
    day: 'Thursday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 4,
  },
  {
    day: 'Friday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 5,
  },
  {
    day: 'Saturday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 6,
  },
  {
    day: 'Sunday',
    open: '',
    close: '',
    caption: 'Closed',
    validate: true,
    sort: 7,
  },
  {
    day: 'Pub Hols',
    open: '',
    close: '',
    caption: 'Closed',
    validate: false,
    sort: 8,
  },
];

const POPULAR_INDUSTRIES = [
  {
    name: 'Plumbers',
    icon: PlumbersIcon,
  },
  {
    name: 'Builders',
    icon: BuildersIcon,
  },
  {
    name: 'Mechanics',
    icon: MechanicsIcon,
  },
  {
    name: 'Hairdressers',
    icon: HairdressersIcon,
  },
  {
    name: 'Cleaners',
    icon: CleanersIcon,
  },
  {
    name: 'Dentists',
    slug: 'dentists',
    icon: DentistIcon,
  },
  {
    name: 'Massage',
    slug: 'massage-therapists',
    icon: MassageIcon,
  },
];

const FREE_BRONZE_CATEGORIES = [
  'accommodation',
  'apartments',
  'asian restaurants',
  'bottle shops',
  'cafes',
  'chinese restaurants',
  'conference & function venues',
  'fast food',
  'food delivery',
  'greek restaurants',
  'hotels',
  'indian restaurants',
  'italian restaurants',
  'malaysian restaurants',
  'mexican restaurants',
  'motels',
  'pizza',
  'restaurants',
  'seafood restaurants',
  'steakhouses',
  'take away food',
  'thai restaurants',
  'things to do',
  'vietnamese restaurants',
  'wedding reception venues',
  'takeaway food',
  'french restaurants',
  'gluten-free restaurants',
  'pop-up restaurants',
  'spanish restaurants',
  'wine tours',
  'beers tours',
  'bar crawl',
  'tapas restaurants',
  'pubs & taverns',
  'taxis',
  'markets',
  'things to do',
  'wine bars',
  'beer tours',
  'cocktail bars',
  'sports bars',
  'rooftop bars',
  'bars',
  'boutiques',
  'nail salons',
  'fitness centres & gyms',
  'personal trainers',
  'yoga',
  'pilates',
  'burgers',
  'fish & chips',
  'waste & recycling centres',
];

const MAX_UPLOADS_PER_PACKAGE = {
  package1: 30,
  package2: 25,
  package3: 20,
  package4: 15,
};

const MAX_PDF_UPLOADS = 10;
const LS_FEATURE_BANNER_URL =
  'https://business.localsearch.com.au/digital-marketing-for-small-businesses/';

const GRAPHQL_ERRORS = {
  INTERNAL_SERVER_ERROR: {
    heading: 'Internal Server Error',
    message: 'Your submission could not be processed. Please try again later.',
  },
  PERSISTED_QUERY_NOT_FOUND: {
    heading: 'Internal Server Error',
  },
  PERSISTED_QUERY_NOT_SUPPORTED: {
    heading: 'Internal Server Error',
  },
  BAD_USER_INPUT: {
    heading: 'Validation Error',
    message: 'Please check your details and try again.',
  },
  GRAPHQL_VALIDATION_FAILED: {
    heading: 'Validation Error',
  },
  GRAPHQL_PARSE_FAILED: {
    heading: 'Validation Error',
  },
  FORBIDDEN: {
    heading: 'Forbidden',
    message: 'You do not have permission to submit this form.',
  },
  UNAUTHENTICATED: {
    heading: 'Unauthenticated',
    message: 'You do not have permission to submit this form.',
  },
};
const FILTER_REVIEW_WORDS = [
  'court',
  'courthouse',
  'sued',
  'suing',
  'fair work',
  'fair trading',
  'ahpra',
  'accc',
  'scam',
  'scammer',
  'scammed',
  'racist',
  'sexist',
  'pedophile',
  'rape',
  'molester',
  'conned',
  'pothead',
  'marijuana',
  'cocaine',
  'methamphetamine',
  'mdma',
  'nangs',
  'heroin',
  'flakka',
  'ecstasy',
  'krokodil',
  'fuck',
  'fucking',
  'fucked',
  'fucker',
  'motherfucker',
  'fuckstick',
  'fuckwit',
  'shit',
  'shitting',
  'shitted',
  'bullshit',
  'crap',
  'crapping',
  'cunt',
  'cunted',
  'cunts',
  'dick',
  'dickhead',
  'wanker',
  'cock',
  'pussy',
  'asshole',
  'arsehole',
  'a-hole',
  'ahole',
  'bastard',
  'nigga',
  'nigger',
  'niga',
  'koon',
  'gronk',
  'pome',
  'pommy',
  'abo',
  'abbo',
  'wog',
  'wog',
  'redskin',
  'kaffir',
  'kafir',
  'negro',
  'negress',
  'golliwogg',
  'chinaman',
  'chink',
  'wagga',
  'beaner',
  'faggot',
  'whore',
  't-bagger',
  'tbagger',
  'gook',
  'dyke',
  'boong',
  'blowjob',
  'ching chong',
  'cum',
  'ballbag',
  'jizz',
  'homo',
  'slanteye',
  'slant-eye',
  'honky',
  'twink',
  'hori',
  'crackwhore',
  'crack whore',
  'yellow bone',
];

const ENABLE_USER_MANAGEMENT = true;

const VACCINATION_DISCLAIMER_CATEGORIES = [
  'Vaccinations',
  'Travel Vaccinations',
];

export {
  ENABLE_USER_MANAGEMENT,
  VACCINATION_DISCLAIMER_CATEGORIES,
  VALIDITY_PROPERTIES,
  MODALS,
  PHONE_REGEX,
  MOBILE_REGEX,
  STANDARD_PHONE_REGEX,
  MISSING_AREACODE_REGEX,
  EMAIL_REGEX,
  CHARACTERS_ONLY_REGEX,
  ALPHANUMERIC_REGEX,
  STATES,
  DEFAULT_LOCATION,
  COOKIES,
  LISTVIEW_PAGE_SIZE,
  PROFILE_REDIRECTS,
  SUBURB_REDIRECTS,
  DIGITAL_MARKETING_LISTVIEW_REDIRECTS,
  CATEGORY_REDIRECTS,
  SORT_BY_FILTERS,
  TRADING_HOURS_FILTER_ICONS,
  WAYS_TO_PAY_FILTER_ICONS,
  SORT_BY_FILTER_ICONS,
  FILTERS,
  LISTVIEW_TITLE_TAGS,
  QUOTES_SERVICES,
  QUOTES_SERVICES_REVERSE,
  TRADING_HOURS_CAPTIONS,
  TRADING_HOURS_CAPTION_COLORS,
  DEFAULT_TRADING_HOURS,
  CATEGORY_EXCLUSIONS,
  POPULAR_INDUSTRIES,
  FREE_BRONZE_CATEGORIES,
  LISTVIEW_PRIMARY_H1,
  LISTVIEW_SECONDARY_HEADING,
  MAX_UPLOADS_PER_PACKAGE,
  MAX_PDF_UPLOADS,
  LS_FEATURE_BANNER_URL,
  GRAPHQL_ERRORS,
  FILTER_REVIEW_WORDS,
  LISTING_POST_STATES,
};
